import React, { useRef } from 'react';
import divider from '../../assets/divider-img.png';
// import algo1 from '../../assets/platforms/1.png';
// import algo2 from '../../assets/platforms/2.png';
// import algo3 from '../../assets/platforms/3.png';
// import algo4 from '../../assets/platforms/4.png';
// import algo5 from '../../assets/platforms/5.png';
// import algo6 from '../../assets/platforms/6.png';
// import algo7 from '../../assets/platforms/7.png';
import s1 from '../../assets/tech-stack/1.png';
import s2 from '../../assets/tech-stack/2.png';
import s3 from '../../assets/tech-stack/3.png';
import s4 from '../../assets/tech-stack/4.png';
import s5 from '../../assets/tech-stack/5.png';
import s6 from '../../assets/tech-stack/6.png';
import s7 from '../../assets/tech-stack/7.png';
import s8 from '../../assets/tech-stack/8.png';
import s9 from '../../assets/tech-stack/9.png';
import s10 from '../../assets/tech-stack/10.png';
import s11 from '../../assets/tech-stack/11.png';
import s12 from '../../assets/tech-stack/12.png';
import s13 from '../../assets/tech-stack/13.png';
import s14 from '../../assets/tech-stack/14.png';
import s15 from '../../assets/tech-stack/15.png';

const BacktestStimulation = () => {
  const windowWidth = useRef(window.innerWidth);
  return (
    <div className="backtest-stimulation">
      <div className="container">
        <div className="center-heading-description">
          <h2>Unveiling Backtesting Simulation</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Our backtesting simulations are comprehensive, replicating real
            market conditions. This ensures that our strategies are tested in
            scenarios that mirror live trading environments.
          </p>
        </div>
        {windowWidth.current <= 968 ? (
          <div className="backtest-stimulation-wrapper">
            <div className="backtest-stimulation-wrapper-left">
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>1</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Replicating Real Markets</h4>
                  <p>
                    We use simulations to understand strategy behavior, refine
                    approaches, and learn without actual risk.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>2</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Trade Execution in the Past</h4>
                  <p>
                    Our backtests simulate how a strategy would have performed
                    in past market conditions.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>3</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Realistic Execution Factors</h4>
                  <p>
                    We account for factors like slippage and liquidity to ensure
                    realistic backtesting results.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>4</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Calculating Performance</h4>
                  <p>
                    Post backtesting, we analyze performance metrics to evaluate
                    the strategy's effectiveness.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>5</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Gaining Insights</h4>
                  <p>
                    The insights derived from backtesting guide further strategy
                    refinement and optimization.
                  </p>
                </div>
              </div>
            </div>
            <div className="backtest-stimulation-wrapper-right">
              <img className="comp-logo-sti" src={s1} alt="trading companies" />
              <img className="comp-logo-sti" src={s2} alt="trading companies" />
              <img className="comp-logo-sti" src={s3} alt="trading companies" />
              <img className="comp-logo-sti" src={s4} alt="trading companies" />
              <img className="comp-logo-sti" src={s5} alt="trading companies" />
              <img className="comp-logo-sti" src={s6} alt="trading companies" />
              <img className="comp-logo-sti" src={s8} alt="trading companies" />
              <img className="comp-logo-sti" src={s9} alt="trading companies" />
              <img
                className="comp-logo-sti"
                src={s10}
                alt="trading companies"
              />
              <img
                className="comp-logo-sti"
                src={s11}
                alt="trading companies"
              />
              <img
                className="comp-logo-sti"
                src={s12}
                alt="trading companies"
              />
              <img
                className="comp-logo-sti"
                src={s13}
                alt="trading companies"
              />
              <img
                className="comp-logo-sti"
                src={s14}
                alt="trading companies"
              />
              <img
                className="comp-logo-sti"
                src={s15}
                alt="trading companies"
              />
            </div>
          </div>
        ) : (
          <div className="backtest-stimulation-wrapper">
            <div className="backtest-stimulation-wrapper-left">
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>1</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Replicating Real Markets</h4>
                  <p>
                    We use simulations to understand strategy behavior, refine
                    approaches, and learn without actual risk.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>2</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Trade Execution in the Past</h4>
                  <p>
                    Our backtests simulate how a strategy would have performed
                    in past market conditions.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>3</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Realistic Execution Factors</h4>
                  <p>
                    We account for factors like slippage and liquidity to ensure
                    realistic backtesting results.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>4</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Calculating Performance</h4>
                  <p>
                    Post backtesting, we analyze performance metrics to evaluate
                    the strategy's effectiveness.
                  </p>
                </div>
              </div>
              <div className="backtest-stimulation-wrapper-left-content">
                <div className="index-numbering">
                  <h4>5</h4>
                </div>
                <div className="stimulation-info">
                  <h4>Gaining Insights</h4>
                  <p>
                    The insights derived from backtesting guide further strategy
                    refinement and optimization.
                  </p>
                </div>
              </div>
            </div>
            <div className="backtest-stimulation-wrapper-right">
              <div className="comp-logo-outter">
                <img
                  className="comp-logo-sti"
                  src={s1}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s2}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s3}
                  alt="trading companies"
                />
              </div>

              <div className="comp-logo-outter">
                <img
                  className="comp-logo-sti"
                  src={s4}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s5}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s6}
                  alt="trading companies"
                />
              </div>

              <div className="comp-logo-outter">
                <img
                  className="comp-logo-sti"
                  src={s7}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s8}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s9}
                  alt="trading companies"
                />
              </div>

              <div className="comp-logo-outter">
                <img
                  className="comp-logo-sti"
                  src={s10}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s11}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s12}
                  alt="trading companies"
                />
              </div>

              <div className="comp-logo-outter">
                <img
                  className="comp-logo-sti"
                  src={s13}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s14}
                  alt="trading companies"
                />
                <img
                  className="comp-logo-sti"
                  src={s15}
                  alt="trading companies"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BacktestStimulation;
